module.exports = __webpack_public_path__ + "static/videoStill-f760310f2114ff978f26d428cde9a3bc.png";